import { Outlet } from "react-router-dom";

export default function WorkflowsLayout() {
  return <Outlet />;
}
